"use client";

import { useEffect } from "react";

const SW_URL = "/sw.js";

export function PwaRegister() {
  useEffect(() => {
    if (!("serviceWorker" in navigator)) {
      return;
    }

    void navigator.serviceWorker
      .register(SW_URL, {
        scope: "/",
        updateViaCache: "none",
      })
      .then((registration) => registration.update().catch(() => undefined))
      .catch((error) => {
        if (process.env.NODE_ENV !== "production") {
          console.error("Service worker registration failed", error);
        }
      });
  }, []);

  return null;
}
